module.exports = __webpack_public_path__ + "img/add_row_before.125aac7e.svg";